(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("PrismicToolbar", [], factory);
	else if(typeof exports === 'object')
		exports["PrismicToolbar"] = factory();
	else
		root["PrismicToolbar"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition